import React from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import './index.css';
import store from '../../config/Store';
import { Home } from './../screens/';
import Match from './../screens/match/Match';
import Login from './../screens/login/Login';
import LogOut from './../screens/logout/LogOut';
import MatchSquad from './../screens/matchSquad/MatchSquad';
import Player from './../screens/player/Player';
import UserRating from './../screens/userRating/UserRating';

const PrivateRoute = ({ component: Component, ...rest }) => {
	return (
		<Route
			{...rest}
			render={props =>
				store.getState().auth.signedIn && store.getState().auth.active ? (
					<Component {...props} />
				) : (
					<Redirect
						to={{
							pathname: '/login',
							state: { from: props.location },
						}}
					/>
				)
			}
		/>
	);
};

const RatingRouter = () => (
	<Router>
		<div>
			<PrivateRoute exact path="/" component={Home} />
			<Route path="/login" component={Login} />
			<PrivateRoute exact path="/players" component={Player} />
			<PrivateRoute exact path="/matches" component={Match} />
			<PrivateRoute exact path="/matches/:number" component={MatchSquad} />
			<Route exact path="/match/:number" component={UserRating} />
			<Route exact path="/match/:season/:number" component={UserRating} />
			<PrivateRoute exact path="/login_out" component={LogOut} />
		</div>
	</Router>
);

export default RatingRouter;



// WEBPACK FOOTER //
// ./src/components/Router/index.js